import { Link } from 'react-router-dom'
import logo from "/logo2.jpg";


export const Header = () => {
  return (
    <div className='h-[11vh] sticky top-0 z-50 transition-all ease-in-out duration-300'>
    <header className="h-[11vh] w-full bg-[#233252] shadow-md  flex justify-between items-center" >
    <div className="bg-gray-800 p-0 overflow-hidden">
    <img src={logo} alt="Logo" className="h-[11vh] m-0 " />
    </div>
    
    <div>
    <nav className="flex flex-row gap-4 mx-6 text-lg my-2 items-center justify-end">

      
      
    </nav>
    <nav className="flex gap-4 mx-6 text-[.9rem] my-2 items-center justify-end">
        <Link to="/traffic-tickets" className="text-[#10b981] hover:text-[#10b981]/70">Facturación</Link>

    </nav>
    </div>
  </header>
   <div className="bg-[#f4f5f5] text-black text-[.9rem] text-center mt-0 py-1">
               
   <p>Si necesitas soporte, puedes comunicarte al siguiente correo electrónico: transito@monterrey.gob.mx</p>
                  </div>
                  </div>
  )
}
